import { render, staticRenderFns } from "./PanelCompetitionSettingSidebar.vue?vue&type=template&id=634a3397&"
import script from "./PanelCompetitionSettingSidebar.vue?vue&type=script&lang=js&"
export * from "./PanelCompetitionSettingSidebar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/vhosts/dostartu.pl/app.startzone.online/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('634a3397')) {
      api.createRecord('634a3397', component.options)
    } else {
      api.reload('634a3397', component.options)
    }
    module.hot.accept("./PanelCompetitionSettingSidebar.vue?vue&type=template&id=634a3397&", function () {
      api.rerender('634a3397', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/PanelCompetitionSettingSidebar.vue"
export default component.exports